import Loadable from 'react-loadable';
import React from 'react';
import Skeleton from '../primitives/skeleton';
export var loadAtlassianSwitcher = function loadAtlassianSwitcher() {
  return import( /* webpackChunkName: "@ak-switcher-chunk-atlassian-switcher" */'./atlassian-switcher').then(function (module) {
    return module.default;
  });
};
export var loadJiraSwitcher = function loadJiraSwitcher() {
  return import( /* webpackChunkName: "@ak-switcher-chunk-jira-switcher" */'./jira-switcher').then(function (module) {
    return module.default;
  });
};
export var loadConfluenceSwitcher = function loadConfluenceSwitcher() {
  return import( /* webpackChunkName: "@ak-switcher-chunk-confluence-switcher" */'./confluence-switcher').then(function (module) {
    return module.default;
  });
};
export var loadGenericSwitcher = function loadGenericSwitcher() {
  return import( /* webpackChunkName: "@ak-switcher-chunk-generic-switcher" */'./generic-switcher').then(function (module) {
    return module.default;
  });
};
export var AtlassianSwitcherLoader = Loadable({
  loader: loadAtlassianSwitcher,
  loading: function loading() {
    return /*#__PURE__*/React.createElement(Skeleton, null);
  }
});
export var JiraSwitcherLoader = Loadable({
  loader: loadJiraSwitcher,
  loading: function loading() {
    return /*#__PURE__*/React.createElement(Skeleton, null);
  }
});
export var ConfluenceSwitcherLoader = Loadable({
  loader: loadConfluenceSwitcher,
  loading: function loading() {
    return /*#__PURE__*/React.createElement(Skeleton, null);
  }
});
export var GenericSwitcherLoader = Loadable({
  loader: loadGenericSwitcher,
  loading: function loading() {
    return /*#__PURE__*/React.createElement(Skeleton, null);
  }
});